import { BaseNumberQuestionNode } from './BaseNumberQuestionNode'

export class NumberQuestionNode extends BaseNumberQuestionNode {}
